/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//SP ページ内ボタン 表示・非表示切り替え
//カートボタンが画面からいなくなったら、カートへ遷移ボタンを表示する
$(document).ready(function () {
  if (window.matchMedia("(max-width: 640px)").matches) {
    $("#modalOpen").hide();
    var top = $("#Product__AddToCartButton").offset().top;
    if ($(window).height() < top) {
      //最初に#btnBlockが見えてない場合
      $("#modalOpen").show();
    }
  }
});

$(window).scroll(function () {
  if (window.matchMedia("(max-width: 640px)").matches) {
    var top = $("#Product__AddToCartButton").offset().top;
    if ($(window).height() > top) {
      // 最初に#btnBlockが見えている場合
      if ($(window).scrollTop() > top) {
        $("#modalOpen").fadeIn();
      } else {
        $("#modalOpen").fadeOut();
      }
    } else {
      // 最初に#btnBlockが見えていない場合
      if (
        $(window).scrollTop() + $(window).height() > top &&
        $(window).scrollTop() < top
      ) {
        $("#modalOpen").fadeOut();
      } else {
        $("#modalOpen").fadeIn();
      }
    }
  }
});

//// 商品詳細 モーダルウィンドウ 
const buttonOpen = document.getElementById('modalOpen');
const modal = document.getElementById('easyModal');
const buttonClose = document.getElementsByClassName('modalClose')[0];

// ボタンがクリックされた時
if (buttonOpen){ 
buttonOpen.addEventListener('click', modalOpen);
}
function modalOpen() {
  modal.style.display = 'block';
}
// バツ印がクリックされた時
if (buttonClose){ 
buttonClose.addEventListener('click', modalClose);
}
function modalClose() {
  modal.style.display = 'none';
}
// モーダルコンテンツ以外がクリックされた時
addEventListener('click', outsideClose);
function outsideClose(e) {
  if (e.target == modal) {
    modal.style.display = 'none';
  }
}

//商品詳細 在庫数に応じてテキスト表示 バリエーションごとにだし分け
const option = document.getElementsByClassName("Popover__Value");
const options = Array.from(option);
const productMetaQuantities = document.querySelectorAll(".ProductMeta_quantity");

options.forEach((option, index) => {
  ////バリエーション変更時の処理
  option.addEventListener("click", () => {
    $(".ProductMeta_quantity").css("display", "none");
    if (productMetaQuantities[index]) {
      productMetaQuantities[index].style.display = "block";
    }
  });
});
